import { ScrollArea, Stack } from '@mantine/core';

export function VaultPropertyFormLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <ScrollArea sx={{ flexGrow: 1 }}>
      <Stack spacing="04" px="00">
        {children}
      </Stack>
    </ScrollArea>
  );
}
